import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'


export const _ScrollToTop = function(props) {
  const location = useLocation()
  const [prevLocation, setPrevLocation] = useState(location)

  useEffect(() => {
    setPrevLocation(location)
  }, [location])

  useEffect(() => {
    if (location !== prevLocation) {
      window.scrollTo(0, 0)
    }
  })

  return props.children
}

export const ScrollToTop = _ScrollToTop
